module.exports = __webpack_public_path__ + "img/project-22.5e147085.png";